import type { AxiosInstance } from 'axios';

// Downloads a file served by an authenticated API endpoint. A plain
// <a href> can't carry the Bearer token, so this fetches as a blob and
// triggers the save via an object URL instead.
export async function downloadFile(
  api: AxiosInstance,
  url: string,
  filename: string,
  params?: Record<string, unknown>
): Promise<void> {
  const res = await api.get<Blob>(url, { responseType: 'blob', params });
  const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}
